import React from 'react';
import { useProgressBar } from '../context/ProgressBarContext';
import styles from './ProgressBar.module.css';

const ProgressBar = () => {
  const { progress, isVisible } = useProgressBar();

  return (
    <div className={`${styles['progress-bar-container']} ${isVisible ? styles.visible : ''}`}>
      <div className={styles['progress-bar-fill']} style={{ width: `${progress}%` }}></div>
    </div>
  );
};

export default ProgressBar;
